import React from 'react';
import { Stage, Layer } from 'react-konva';
import ExportCanvasImage from './ExportCanvasImage';
const ExportCanvas = ({ scaleMultiplier, sideName, canvasWidthMM, canvasHeightMM, imageDimensions, uploadedImages, pxConverter, canvasRef, }) => {
    if (uploadedImages.length != imageDimensions.length) {
        return null;
    }
    return (React.createElement("div", { className: "hg-export-canvas" },
        React.createElement(Stage, { className: "konva-stage", "data-hg-export": sideName, ref: canvasRef, width: canvasWidthMM * pxConverter, height: canvasHeightMM * pxConverter },
            React.createElement(Layer, null, uploadedImages != null
                ? uploadedImages.map((image, index) => (React.createElement(ExportCanvasImage, { key: index, image: image, width: imageDimensions[index].widthMM * pxConverter, height: imageDimensions[index].heightMM * pxConverter, xPos: (imageDimensions[index].position.x / scaleMultiplier) * pxConverter, yPos: (imageDimensions[index].position.y / scaleMultiplier) * pxConverter, rotation: imageDimensions[index].position.rotation })))
                : null))));
};
export default ExportCanvas;
